import { createFormTracker, FormTracker } from '@rs/form-tracking-sdk';
import { isSyntheticMonitor } from './syntheticMonitor';

const realFormTracker = createFormTracker({
  formId: 'elp/taxForms'
});

export const formTracker: FormTracker = {
  trackStepView: (data) => {
    if (isSyntheticMonitor()) return;
    realFormTracker.trackStepView(data);
  },
  trackStepSkip: (data) => {
    if (isSyntheticMonitor()) return;
    realFormTracker.trackStepSkip(data);
  },
  trackValidSubmission: (data) => {
    if (isSyntheticMonitor()) return;
    realFormTracker.trackValidSubmission(data);
  },
  trackInvalidSubmission: () => {
    if (isSyntheticMonitor()) return;
    realFormTracker.trackInvalidSubmission();
  },
  trackConfirmation: (data) => {
    if (isSyntheticMonitor()) return;
    realFormTracker.trackConfirmation(data);
  },
  trackModule: (data) => {
    if (isSyntheticMonitor()) return;
    realFormTracker.trackModule(data);
  },
  registerFormElement: (formElement) => {
    if (isSyntheticMonitor()) return;
    realFormTracker.registerFormElement(formElement);
  },
  trackError: (data) => {
    if (isSyntheticMonitor()) return;
    realFormTracker.trackError(data);
  }
};
